import { Component, Vue } from 'vue-property-decorator';
import { store } from '@/store';
import { reloadSession, goNextGalaxy } from '@/galaxy-cruise/utils';

@Component
export default class extends Vue {
  async quit() {
    location.href = '..'
  }

  freeSailing() {
    this.$emit('resolve')
  }

  async continueToCruise() {
    this.$emit('resolve')
    store.galaxyCruise.series = 'infinite'
    const globe = store.currentGlobe()
    globe.viewFactory.jumpTo({}, { duration: 0 })
    await reloadSession()
    await goNextGalaxy(5000)
  }
}
